import { configureStore, configureStore as ConfigureStoreToolkit, getDefaultMiddleware } from "@reduxjs/toolkit";
import { avatarsReducer } from "./avatars/reducers";
import { clientPromoteReducer } from "./clientPromote/reducers";
import { connectionReducer } from "./connection/reducers";
import { discoveryReducer } from "./discovery/reducers";
import { draftReducers } from "./draft/reducers";
import { ivandReducer } from "./ivand/reducers";
import { messengerReducer } from "./messenger/reducers";
import { roomsReducer } from "./rooms/reducers";
import { signalingReducer } from "./signaling/reducers";
import { signalingLogListReducer } from "./signalingLogList/reducers";
import { storiesReducer } from "./stories/reducers";
import { usersReducer } from "./users/reducers";
import { messagesReducer } from "./messages/reducers";
import createSagaMiddleware from "@redux-saga/core";
import RootSaga from "./rootSaga";

// export function makeStoreNew(preLoadedState ?: Object) {
//     return ConfigureStoreToolkit({
//         reducer: {
// player: playerReducer,
//         },
//         preloadedState: preLoadedState ?? undefined
//     })
// }

// const storeNew = makeStoreNew()
// export default storeNew

const sagaMiddleware = createSagaMiddleware();
const middleware = [...getDefaultMiddleware({ thunk: false }), sagaMiddleware];

//using redux ToolKit
const store = configureStore({
  reducer: {
    avatars: avatarsReducer,
    clientPromote: clientPromoteReducer,
    connection: connectionReducer,
    discovery: discoveryReducer,
    draft: draftReducers,
    ivand: ivandReducer,
    messages: messagesReducer,
    messenger: messengerReducer,
    rooms: roomsReducer,
    signaling: signalingReducer,
    signalingLogList: signalingLogListReducer,
    stories: storiesReducer,
    users: usersReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware,
});

sagaMiddleware.run(RootSaga);

export type ReducersType = ReturnType<typeof store.getState>;
export default store;
